<template>
  <div class="slider">
    <div
      :class="['slider__button', 'slider__button--left', leftActive ? '' : 'slider__button--inactive']"
      @click="pushItems('toRight')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.677 18.52c.914 1.523-.183 3.472-1.967 3.472h-19.414c-1.784 0-2.881-1.949-1.967-3.472l9.709-16.18c.891-1.483 3.041-1.48 3.93 0l9.709 16.18z"/></svg>
    </div>

    <div
      :ref="'slider_' + name"
      :id="'slider_' + name"
      class="slider__content"
      @mousedown="pushed = false"
      @touchstart="pushed = false"
    >
      <div
        :ref="'slider_' + name + '_items'"
        :id="'slider_' + name + '_items'"
        :class="['slider__items', pushed ? 'slider__items--transition' : '']"
        :style="'margin-left:' + drag.current + 'px'"
      >
        <transition-group
          name="slider__transition"
          tag="div"
          appear
          appear-class="slider__transition-appear"
          style="display: flex;"
        >
          <UtilityItem
            v-for="resultId in displayedResults()"
            :class="['slider__item', displayedResults().length >= 5 ? 'slider__item--noBorder' : '', 'slider__transition-item', !resultId.loading && selectedResultId && selectedResultId === results.byId[resultId].id ? 'slider__item--selected' : '']"
            :ref="'slider_item_' + resultId"
            :key="!resultId.loading ? resultId + results.byId[resultId].attributes.licensed : 'SLIDER_ITEM' + resultId.num"
            :resultId="!resultId.loading ? resultId : ''"
            :result="!resultId.loading ? results.byId[resultId] : {}"
            :url="!resultId.loading ? '/' + results.byId[resultId].type + '/' + results.byId[resultId].id : '#'"
            :title="!resultId.loading ? results.byId[resultId].attributes.title : ''"
            :type="type"
            :data="!resultId.loading ? results.byId[resultId].attributes.data_series : {}"
            :licensed="!resultId.loading ? results.byId[resultId].attributes.licensed : false"
            :trial="!resultId.loading ? results.byId[resultId].attributes.trial : false"
            :free="!resultId.loading ? results.byId[resultId].attributes.free : false"
            :loading="loading"
            :height="136"
            :isSlider="true"
            :selected="!resultId.loading && selectedResultId && selectedResultId === results.byId[resultId].id ? true : false"
            @click.native="clicked({ 'id': results.byId[resultId].id, 'hash': resultId, 'type': results.byId[resultId].type })"
            @highlighted="highlightItem(resultId)"
            @downplayed="downplayItem(resultId)"
          />
        </transition-group>
      </div>
    </div>

    <div
      :class="['slider__button', 'slider__button--right', rightActive ? '' : 'slider__button--inactive']"
      @click="pushItems('toLeft')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.677 18.52c.914 1.523-.183 3.472-1.967 3.472h-19.414c-1.784 0-2.881-1.949-1.967-3.472l9.709-16.18c.891-1.483 3.041-1.48 3.93 0l9.709 16.18z"/></svg>
    </div>
  </div>
</template>

<script>
import UtilityItem from '@/components/utility/Item.vue'
import helperMethods from '@/helpers/utility.js'

export default {
  components: {
    UtilityItem
  },
  props: {
    name: {
      type: String,
      default: 'slider'
    },
    type: {
      type: String,
      default: 'datasets'
    },
    selectedResultId: {
      type: [Boolean, String],
      default: false
    },
    results: {
      type: Object,
      default: function () {
        return {}
      }
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      mounted: false,
      pushed: false,
      drag: {
        current: 0,
        x: 0,
        dragging: false,
        preventToggle: false
      }
    }
  },
  computed: {
    leftActive () {
      if (this.mounted) {
        let check = this.drag.current < 0 ? true : false
        return check
      }

      return true
    },
    rightActive () {
      if (this.mounted) {
        let check = (this.$refs['slider_' + this.name + '_items'].offsetWidth + this.drag.current) > this.$refs['slider_' + this.name].clientWidth ? true : false
        return check
      }

      return true
    }
  },
  methods: {
    clicked (value) {
      let name = this.results.byId[value.hash].attributes.title ? this.results.byId[value.hash].attributes.title : (this.results.byId[value.hash].attributes.name ? this.results.byId[value.hash].attributes.name : value.id)
      if (name && name !== '') {
        this.sendGoogleAnalyticsEvent('document_' + value.type + '_open', name, 'related_slider', this.$store.getters['user/getSubscriptionStatus'])
      }
      this.$emit('clicked', value)
    },
    highlightItem (value) {
      this.$emit('highlightedItem', value)
    },
    downplayItem (value) {
      this.$emit('downplayedItem', value)
    },
    pushItems (direction) {
      let newXPos = 0

      if (direction === 'toLeft') {
        newXPos = this.drag.x - this.$refs['slider_' + this.name].clientWidth + 40
      } else if (direction === 'toRight') {
        newXPos = this.drag.x + this.$refs['slider_' + this.name].clientWidth - 40
      }

      this.dragItems(newXPos)
      this.pushed = true
    },
    dragItems (xPos) {
      if (this.$refs['slider_' + this.name + '_items'].offsetWidth > this.$refs['slider_' + this.name].clientWidth) {
        if (this.drag.current + xPos - this.drag.x > 0) {
          this.drag.current = 0
          this.drag.x = xPos
        } else if (this.drag.current + xPos - this.drag.x < this.$refs['slider_' + this.name].clientWidth - this.$refs['slider_' + this.name + '_items'].offsetWidth) {
          this.drag.current = this.$refs['slider_' + this.name].clientWidth - this.$refs['slider_' + this.name + '_items'].offsetWidth
          this.drag.x = xPos
        } else {
          this.drag.current = this.drag.current + xPos - this.drag.x
          this.drag.x = xPos
        }
      }
    },
    displayedResults () {
      let displayedResults = []
      let displayable = 10

      if (this.results && this.results.allIds && this.results.allIds.length < displayable) {
        displayable = this.results.allIds.length
      }

      for (let i=0; i<displayable; i++) {
        if (this.results && this.results.allIds && this.results.allIds[i]) {
          displayedResults.push(this.results.allIds[i])
        } else {
          displayedResults.push({ 'loading': true, 'num': '_' + i })
        }
      }

      return displayedResults
    },
    ...helperMethods
  },
  mounted () {
    document.getElementById('slider_' + this.name).addEventListener('mousedown', e => {
      this.drag.x = e.clientX
      this.drag.dragging = true
      let that = this

      setTimeout(function () {
        if (that.drag.dragging === true) {
          that.drag.preventToggle = true
        }
      }, 500)
    }, { passive: true})

    document.getElementById('slider_' + this.name).addEventListener('touchstart', e => {
      if (e.targetTouches[0]) {
        this.drag.x = e.targetTouches[0].pageX
        this.drag.dragging = true
      }
    }, { passive: true})

    window.addEventListener('mousemove', e => {
      if (this.drag.dragging === true) {
        this.dragItems(e.clientX)
      } else {
        this.drag.preventToggle = false
      }
    }, { passive: true})

    window.addEventListener('mouseup', e => {
      if (this.drag.dragging === true) {
        this.dragItems(e.clientX)
        this.drag.x = 0
        this.drag.dragging = false
        let that = this

        setTimeout(function () {
          that.drag.preventToggle = false
        }, 10)
      }
    }, { passive: true})

    window.addEventListener('touchmove', e => {
      if (e.targetTouches[0]) {
        if (this.drag.dragging === true) {
          this.dragItems(e.targetTouches[0].pageX)
        } else {
          this.drag.preventToggle = false
        }
      }
    }, { passive: true})

    window.addEventListener('touchend', e => {
      if (e.targetTouches[0]) {
        if (this.drag.dragging === true) {
          this.dragItems(e.targetTouches[0].pageX)
          this.drag.x = 0
        }
      }
      this.drag.dragging = false
    }, { passive: true})

    this.mounted = true
  },
  unmounted () {
    window.removeEventListener('mousedown', this.nextItem)
    window.removeEventListener('mouseup', this.nextItem)
    window.removeEventListener('mousemove', this.nextItem)
    window.removeEventListener('touchstart', this.nextItem)
    window.removeEventListener('touchend', this.nextItem)
    window.removeEventListener('touchmove', this.nextItem)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.slider {
  //@include font('content--sm');
  position: relative;
  line-height: 0;
  background-color: $bg-4;
  //border-top: 1px solid rgba($white, 0.1);
  display: flex;
  flex-direction: row;
  align-items: center;
  //white-space: nowrap;
  width: 100%;
  user-select: none;

  &:hover {
    .slider__button {
      background-color: $bg-2;
      fill: rgba($white, 0.1);
    }

    .slider__button:not(.slider__button--inactive) {
      background-color: $bg-2;
      fill: rgba($white, 0.7);
    }
  }

  &__button {
    position: absolute;
    z-index: 9;
    display: flex;
    border-radius: 999px;
    align-items: center;
    user-select: none;
    padding: 7px 8px 9px 8px;
    transition: background-color 0.2s ease-out;
    //background-color: $bg-1;
    fill: $bg-2;

    &:hover:not(.slider__button--inactive) {
      fill: $white !important;
      cursor: pointer;

      svg {
        transform: scale(1.15);
      }
    }

    &:focus, &:active {
      svg {
        transform: scale(1) !important;
      }
    }

    &--left {
      transform: rotate(270deg);
      //margin: 0px 6px 0px 2px;
      left: 2px;

      @media screen and (min-width: $breakpointLg) {
        margin-right: 7px;
      }
    }

    &--right {
      transform: rotate(90deg);
      //margin: 0px 6px;
      right: 2px;

      @media screen and (min-width: $breakpointLg) {
        margin: 0px 7px;
      }
    }

    &--left.slider__button--header, &--left.slider__button--timeline, &--left.slider__button--legend {
      transform: rotate(270deg);
      margin: 0px 2px 0px 6px;

      @media screen and (min-width: $breakpointLg) {
        margin-right: 7px;
      }
    }

    &--right.slider__button--header, &--right.slider__button--timeline, &--right.slider__button--legend {
      transform: rotate(90deg);
      margin: 0px 6px 0px 2px;

      @media screen and (min-width: $breakpointLg) {
        margin: 0px 7px;
      }
    }

    svg {
      transition: fill 0.2s ease-out;
      width: 14px;
      height: 14px;

      @media screen and (min-width: $breakpointLg) {
        width: 16px;
        height: 16px;
      }
    }
  }

  &__content {
    position: relative;
    //top: -1px;
    z-index: 5;
    flex: 1;
    //height: 160px;
    overflow: hidden;
    //white-space: nowrap;
    transition: background-color 0.2s ease-out;
    cursor: col-resize;
  }

  &__items {
    //height: 160px;
    display: inline-flex;
    align-items: center;

    &--transition {
      transition: margin 0.5s ease-in-out;

      @media screen and (min-width: $breakpointSm) {
        transition: margin 0.6s ease-in-out;
      }

      @media screen and (min-width: $breakpointMd) {
        transition: margin 0.7s ease-in-out;
      }

      @media screen and (min-width: $breakpointLg) {
        transition: margin 0.8s ease-in-out;
      }
    }
  }

  &__item {
    position: relative;
    width: 304px;
    //height: 144px;
    padding: 8px;
    background-color: $bg-4;
    border-top: 1px solid rgba($white, 0.1);
    border-left: 1px solid rgba($white, 0.1);
    border-right: 1px solid $black;

    &--noBorder {
      &:last-child:not(:first-child) {
        border-right: none;
      }
    }

    &:after {
      content: '';
      position: absolute;
      right: -2px;
      top: -2px;
      height: calc(100% + 2px);
      border-right: 1px solid rgba($white, 0.1);
    }

    &:first-child {
      border-left: 1px solid rgba($white, 0);
      transition: none;
    }

    &:hover, &--selected {
      background-color: $bg-2;
    }
  }
}

.slider__transition-item {
  transition: opacity 0.6s;
}
.slider__transition-enter-active, .slider__transition-leave-active {
  transition: opacity 0.6s;
}
.slider__transition-enter, .slider__transition-leave-to {
  opacity: 0;
  //transform: scale(0.9); //translateY(32px);
}
.slider__transition-appear {
  transition: all 0s;
}
.slider__transition-leave-active {
  position: absolute;
}

</style>
